import React from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';
import PropTypes from 'prop-types';

import SpinnerComponent from '../../../components/SpinnerComponent';
import IndietroButton from '../../../components/IndietroButton';
import SelezioneGruppo from '../components/SelezioneGruppo';

import { registerConsulente } from '../../../utils/api/consulenti_api';
import { getGruppi } from '../../../utils/api/gruppi_api';

import validator from 'validator';

import AuthTypeSelector from '../components/AuthTypeSelector.jsx';
import { AUTH_OPTIONS, AUTH_TYPES } from '../../../auth/auth.options.js';
import PasswordFieldsCollapse from '../components/PasswordFieldsCollapse.jsx';
import { reportApiError } from '../../../utils/reportApiError';

const styles = {
  mainContainer: {
    paddingLeft: '4px',
    paddingRight: '4px',
    maxWidth: '840px',
    minHeight: '500px',
  },
  sectioncontainer: {
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    marginTop: '10px',
    marginBottom: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  userdatacontainer: {
    marginTop: '10px',
    marginBottom: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  textfield: {
    marginBottom: '12px',
    width: '320px',
  },
};

const getAuthTypeFromFlags = (record) => {
  // con i radio vuoi sempre 1 selezione => se non è LOCAL, è Microsoft SSO
  return record.passwordEnabled ? AUTH_TYPES.LOCAL : AUTH_TYPES.MICROSOFT_SSO;
};

export default class RegistraConsulente extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      record: {
        email: '',
        nome: null,
        password: '',
        confirmPassword: '',
        cognome: null,
        telefono: null,
        terminiUsoAccettati: false,
        privacyPolicyAccettata: false,
        partitaIva: null,
        codiceSdi: null,
        pec: null,
        gruppoId: null,
        superconsulente: false,
        passwordEnabled: true,
        oauthEnabled: false,
      },
      validationErrors: {
        email: '',
        password: '',
        confirmPassword: '',
        gruppoId: '',
      },
      gruppi: [],
      showPassword1: false,
      showPassword2: false,
      loading: false,
      disableForm: false,
      saveButtonEnabled: false,
    };
  }

  componentDidMount() {
    let id = this.props.gruppoId;
    if (id !== null) {
      let record = this.state.record;
      record.gruppoId = id;
      this.setState({
        record,
      });
    }
    if (!this.props.superconsulenteView) {
      this.fetchGruppi();
    }
  }

  fetchGruppi = () => {
    this.setState({
      loading: true,
    });
    getGruppi(null, null, 0, 1000, 'nome')
      .then((result) => {
        let gruppoId = this.state.record.gruppoId;
        let record = this.state.record;
        for (let i = 0; i < result.length; i++) {
          if (gruppoId === null) {
            if (result[i].nome === 'BSFOOD') {
              gruppoId = result[i].id;
              break;
            }
          }
        }
        record.gruppoId = gruppoId;
        this.setState({
          loading: false,
          gruppi: result,
          record,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  handleClickShowPassword1 = () => {
    let flag = this.state.showPassword1;
    this.setState({
      showPassword1: !flag,
    });
  };

  handleClickShowPassword2 = () => {
    let flag = this.state.showPassword2;
    this.setState({
      showPassword2: !flag,
    });
  };

  validateForm = () => {
    const data = this.state.record;
    let validationErrors = { ...this.state.validationErrors };

    Object.keys(data).forEach((key) => {
      if (
        !data.passwordEnabled &&
        (key === 'password' || key === 'confirmPassword')
      )
        return;
      validationErrors = {
        ...validationErrors,
        ...this.validateField(key, data[key]),
      };
    });

    this.setState({ validationErrors });

    return Object.values(validationErrors).every((val) => val.length === 0);
  };

  // Returns the message for the field, keyed by its name; fields it does not
  // validate return nothing.
  validateField = (key, value) => {
    switch (key) {
      case 'email':
        if (value.length === 0) {
          return { email: "Inserire l'indirizzo email" };
        }
        return {
          email: validator.isEmail(value)
            ? ''
            : "L'indirizzo email inserito non è valido",
        };
      case 'password':
        return {
          password:
            value.length >= 8
              ? ''
              : 'Inserire una password di almeno 8 caratteri',
        };
      case 'confirmPassword':
        if (value.length === 0) {
          return { confirmPassword: 'Ripetere la password' };
        }
        return {
          confirmPassword:
            value === this.state.record.password
              ? ''
              : 'Le due password non corrispondono',
        };
      case 'gruppoId':
        // A superconsultant registers into their own group, which the page
        // does not pick.
        if (this.props.superconsulenteView) {
          return {};
        }
        return { gruppoId: value === null ? 'Selezionare un gruppo' : '' };
      default:
        return {};
    }
  };

  handleChange = (event) => {
    this.handleFormChange(event.target.name, event.target.value);
  };

  handleCheckboxValue = (event) => {
    this.handleFormChange(event.target.name, event.target.checked);
  };

  handleFormChange = (fielName, value) => {
    this.props.onFormModified();
    if (!this.state.saveButtonEnabled) {
      this.setState({
        saveButtonEnabled: true,
      });
    }
    let validationErrors = this.state.validationErrors;
    let data = this.state.record;
    data[fielName] = value;
    //Reset validation :
    if (
      fielName === 'email' ||
      fielName === 'password' ||
      fielName === 'confirmPassword' ||
      fielName === 'gruppoId'
    ) {
      validationErrors[fielName] = '';
    }
    this.setState({
      record: data,
      validationErrors,
    });
  };

  handleAuthTypeChange = (selected) => {
    const isLocal = selected === AUTH_TYPES.LOCAL;
    this.props.onFormModified();

    this.setState((prevState) => ({
      record: {
        ...prevState.record,
        passwordEnabled: isLocal,
        oauthEnabled: !isLocal,
        ...(isLocal ? {} : { password: '', confirmPassword: '' }),
      },
      validationErrors: {
        ...prevState.validationErrors,
        email: '',
        password: '',
        confirmPassword: '',
      },
    }));
  };

  handleSubmit = (event) => {
    event.preventDefault();
    let isFormValid = this.validateForm();
    if (isFormValid) {
      this.setState({
        loading: true,
      });
      registerConsulente(this.props.superconsulenteView, this.state.record)
        .then((result) => {
          this.setState({
            loading: false,
            saveButtonEnabled: false,
            disableForm: true,
          });
          this.props.onFormSubmitted();
        })
        .catch((error) => {
          let enableSave = true;
          if (error.status === 409) {
            enableSave = false;
          }
          this.setState({
            loading: false,
            saveButtonEnabled: enableSave,
          });
          reportApiError(error);
        });
    } //no-op if form is not valid
  };

  handleSelectedGruppo = (gruppoId) => {
    this.handleFormChange('gruppoId', gruppoId);
  };

  render() {
    const authType = getAuthTypeFromFlags(this.state.record);
    const isLocalAuth = authType === AUTH_TYPES.LOCAL;

    const disabledSubmitbutton =
      this.state.loading || !this.state.saveButtonEnabled;

    return (
      <Container id="form_container" style={styles.mainContainer}>
        {this.state.loading ? (
          <SpinnerComponent size={24} />
        ) : (
          <form autoComplete="off" onSubmit={this.handleSubmit}>
            <Grid container justify="center" alignItems="center">
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                style={styles.sectioncontainer}
              >
                <Typography
                  variant="h5"
                  style={{ paddingTop: '6px', paddingBottom: '6px' }}
                >
                  Dati utente
                </Typography>
                <Grid container style={styles.userdatacontainer}>
                  <AuthTypeSelector
                    value={authType}
                    options={AUTH_OPTIONS}
                    onChange={this.handleAuthTypeChange}
                    disabled={this.state.disableForm}
                  />
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Grid
                      container
                      direction="column"
                      alignItems="center"
                      style={{ paddingBottom: '10px' }}
                    >
                      <TextField
                        id="nuovo-consulente-email"
                        label="Email"
                        required
                        value={
                          this.state.record.email === null
                            ? ''
                            : this.state.record.email
                        }
                        name="email"
                        onChange={this.handleChange}
                        disabled={this.state.disableForm}
                        style={styles.textfield}
                        helperText={this.state.validationErrors.email}
                        error={this.state.validationErrors.email.length > 0}
                      />
                      <PasswordFieldsCollapse
                        open={isLocalAuth}
                        disabled={this.state.disableForm}
                        required={isLocalAuth}
                        passwordValue={this.state.record.password}
                        confirmPasswordValue={this.state.record.confirmPassword}
                        passwordError={this.state.validationErrors.password}
                        confirmPasswordError={
                          this.state.validationErrors.confirmPassword
                        }
                        showPassword1={this.state.showPassword1}
                        showPassword2={this.state.showPassword2}
                        onToggleShowPassword1={this.handleClickShowPassword1}
                        onToggleShowPassword2={this.handleClickShowPassword2}
                        onChange={this.handleChange}
                      />

                      <TextField
                        id="nuovo-consulente-nome"
                        label="Nome"
                        value={
                          this.state.record.nome === null
                            ? ''
                            : this.state.record.nome
                        }
                        name="nome"
                        onChange={this.handleChange}
                        disabled={this.state.disableForm}
                        style={styles.textfield}
                      />
                      <TextField
                        id="nuovo-consulente-cognome"
                        label="Cognome"
                        value={
                          this.state.record.cognome === null
                            ? ''
                            : this.state.record.cognome
                        }
                        name="cognome"
                        onChange={this.handleChange}
                        disabled={this.state.disableForm}
                        style={styles.textfield}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Grid
                      container
                      direction="column"
                      alignItems="center"
                      style={{ paddingBottom: '10px' }}
                    >
                      <TextField
                        id="nuovo-consulente-telefono"
                        label="Telefono"
                        value={
                          this.state.record.telefono === null
                            ? ''
                            : this.state.record.telefono
                        }
                        name="telefono"
                        onChange={this.handleChange}
                        disabled={this.state.disableForm}
                        style={styles.textfield}
                      />
                      <TextField
                        id="nuovo-consulente-partita-iva"
                        label="Partita IVA"
                        value={
                          this.state.record.partitaIva === null
                            ? ''
                            : this.state.record.partitaIva
                        }
                        name="partitaIva"
                        onChange={this.handleChange}
                        disabled={this.state.disableForm}
                        style={styles.textfield}
                      />
                      <TextField
                        id="nuovo-consulente-codice-sdi"
                        label="Codice SDI"
                        value={
                          this.state.record.codiceSdi === null
                            ? ''
                            : this.state.record.codiceSdi
                        }
                        name="codiceSdi"
                        onChange={this.handleChange}
                        disabled={this.state.disableForm}
                        style={styles.textfield}
                      />
                      <TextField
                        id="nuovo-consulente-pec"
                        label="PEC"
                        value={
                          this.state.record.pec === null
                            ? ''
                            : this.state.record.pec
                        }
                        name="pec"
                        onChange={this.handleChange}
                        disabled={this.state.disableForm}
                        style={styles.textfield}
                      />
                    </Grid>
                  </Grid>
                  {!this.props.superconsulenteView ? (
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="superconsulente"
                            checked={this.state.record.superconsulente}
                            onChange={this.handleCheckboxValue}
                            style={{
                              color: this.props.theme.palette.primary.main,
                              '&.MaterialUiChecked': {
                                color: this.props.theme.palette.primary.main,
                              },
                            }}
                            disabled={this.state.disableForm}
                          />
                        }
                        label="Selezionare la casella per assegnare il ruolo di superconsulente:"
                        labelPlacement="start"
                      />
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
            {!this.props.superconsulenteView ? (
              <Container style={styles.sectioncontainer}>
                <Typography variant="h6">Dati gruppo</Typography>
                <SelezioneGruppo
                  gruppoId={this.state.record.gruppoId}
                  gruppi={this.state.gruppi}
                  disabled={this.state.disableForm}
                  description="Scegliere il gruppo di appartenenza del nuovo consulente."
                  onGruppoSelected={this.handleSelectedGruppo}
                />
                {this.state.validationErrors.gruppoId.length > 0 ? (
                  <FormHelperText error>
                    {this.state.validationErrors.gruppoId}
                  </FormHelperText>
                ) : null}
              </Container>
            ) : null}
            <Grid
              container
              justify="center"
              style={{ paddingTop: '10px', paddingBottom: '20px' }}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                style={{ textAlign: 'right' }}
              >
                <IndietroButton isDisabled={this.state.loading} />
                <Button
                  type="button"
                  onClick={this.handleSubmit}
                  variant="contained"
                  size="medium"
                  disabled={disabledSubmitbutton}
                  style={{
                    color: disabledSubmitbutton
                      ? this.props.theme.palette.text.disabled
                      : this.props.theme.palette.text.main,
                    margin: '10px',
                    backgroundColor: disabledSubmitbutton
                      ? this.props.theme.palette.disabled.main
                      : this.props.theme.palette.primary.main,
                  }}
                >
                  Registra
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Container>
    );
  }
}

RegistraConsulente.propTypes = {
  onFormModified: PropTypes.func.isRequired,
  onFormSubmitted: PropTypes.func.isRequired,
  gruppoId: PropTypes.number,
  superconsulenteView: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
};
